import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminSurveysList from "@/features/surveys/components/admin/AdminSurveysList";
import { useSurveysPermissions } from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllSurveys, userCanViewAllSurveys } = useSurveysPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Surveys", link: null },
        ]}
      />
      <h1>Survey Management</h1>

      {userCanViewAllSurveys && (
        <p>
          <Button
            color="primary"
            component={Link}
            to="/app/admin/surveys/new"
            variant="contained"
            size="small"
            disabled={!userCanEditAllSurveys}
          >
            Add Survey
          </Button>
        </p>
      )}

      <AdminSurveysList
        itemsPerPage={25}
        renderVersion={0}
        tableSize="medium"
        userCanEditAllSurveys={userCanEditAllSurveys}
        userCanViewAllSurveys={userCanViewAllSurveys}
      />
    </>
  );
}
